import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import academicsAPI from "../api/academicsApi";

const Academics = () => {
  const [academics, setAcademics] = useState([]);
  const [academicStructure, setAcademicStructure] = useState([]);

  useEffect(() => {
    fetchAcademics();
  }, []);

  const fetchAcademics = async () => {
    const res = await academicsAPI.academics_listing();

    if (res.code === 200) {
      const result = res.data;

      setAcademics(result?.academics);
      setAcademicStructure(result?.academics_structure);
    }
  };

   const info = academics[0];

  return (
    <>
      <BreadCrumbBanner
        title="Academics"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* academics */}
       {info && (
        <section className="acad-intro-section">
          <div className="container">
            <div className="acad-intro-wrap text-center">
              <span className="mrv-subtitle">{info.title}</span> 
              <h2 className="mrv-title">{info.subtitle}</h2>
              <p
                className="acad-description"
                dangerouslySetInnerHTML={{ __html: info.shortdescription }} 
              />
            </div>
          </div>
        </section>
      )}

      {/* academic foundation */}
      {info && (
        <section className="acad-overview-section">
          <div className="container">
            <div className="row align-items-center g-5">
              {/* LEFT IMAGE */}
              <div className="col-lg-6">
                <div className="acad-overview-img">
                  <img
                    src={info.image}  
                    alt="Academics"
                    loading="lazy"
                    className="img-fluid"
                  />
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-6">
                <div className="acad-overview-content">
                  <span className="acad-tag">{info.maintitle}</span>
                  <h2>{info.mainsubtitle}</h2>                        
                  <div dangerouslySetInnerHTML={{ __html: info.description }} />  
                </div>
              </div>
            </div>
          </div>
        </section>
      )}


      {/* learning journey */}
     {academicStructure && academicStructure.length > 0 && (
        <section className="acad-structure-section">
          <div className="container">
            <div className="text-center mb-5">
              <span className="mrv-subtitle">Academic Structure</span>
              <h2 className="mrv-title">Learning Journey at MRV School</h2>
            </div>

            <div className="row g-4">
              {academicStructure.map((item) => (   
                <div key={item.id} className="col-lg-3 col-md-6">
                  <div className="acad-structure-card">
                    <div className="acad-class">{item.title}</div>
                    <h5>{item.subtitle}</h5>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Academics;
